import { combineReducers } from 'redux';

import * as types from 'modules/auth/actionTypes';
import { LOGIN_STEPS } from 'modules/auth/constant';
import type { SetAuthStepAction } from 'modules/auth/types';
import type { Action } from 'modules/global/generic.types';
import error from 'modules/global/reducers/generic.error';
import loading from 'modules/global/reducers/generic.loading';
import type { Nullable } from 'modules/global/typing/common/common';

import authStep from './authStep';

const resetOnLoginStep = {
  matcher: (action: Action): boolean =>
    action.type === types.SET_AUTH_STEP && (action as SetAuthStepAction).payload.step === LOGIN_STEPS.LOGIN,
  reducer: (): Nullable<Error> => null,
};

export default combineReducers({
  authStep,
  signInLoading: loading(types.SIGN_IN_REQUEST),
  resendLoading: loading(types.RESEND_VERIFY_CODE_REQUEST),
  verifySignInError: error<Error>(types.VERIFY_SIGN_IN_REQUEST, {
    matchers: [resetOnLoginStep],
  }),
  verifySignInLoading: loading(types.VERIFY_SIGN_IN_REQUEST),
  forgotPasswordLoading: loading(types.FORGOT_PASSWORD_REQUEST),
  forgotPasswordSubmitLoading: loading(types.FORGOT_PASSWORD_SUBMIT_REQUEST),
});
